import { createSelector } from "@ngrx/store";

import { selectProductClaim } from "../authentication";
import { AppState } from "../store";
import { ProductState } from "./product.reducers";

const feature = (state: AppState) => state.product;

export const availableProductsDetailsSelector = createSelector(
  feature,
  (state: ProductState) => state.availableProductsDetails
);

export const productSelector = createSelector(
  availableProductsDetailsSelector,
  selectProductClaim,
  (availableProducts, productId) =>
    availableProducts?.find(product => product.id === productId) || null
);
